import { useCallback, useState } from 'react';
import { faqList, navCategories, navEntries } from '@/mocks/nav';
import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import EntryExplorer from '@/pages/home/components/EntryExplorer';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import GuideSection from '@/pages/home/components/GuideSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import ContactSection from '@/pages/home/components/ContactSection';
import SiteFooter from '@/pages/home/components/SiteFooter';
import BackToTop from '@/pages/home/components/BackToTop';

const SITE_URL = 'https://douyuwanglk.cn';

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '黑料导航网',
      alternateName: '黑料导航',
      url: `${SITE_URL}/`,
      description:
        '黑料导航网汇集全网吃瓜黑料入口，提供直达地址、首页链接与网址导航，持续收录最新入口。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}/?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '黑料导航网',
      url: `${SITE_URL}/`,
      email: 'feedback@heiliaodh.com',
      description: '吃瓜爆料入口聚合导航，提供分类浏览、关键词搜索与入口地址收录。',
    },
    {
      '@type': 'WebPage',
      name: '黑料导航 - 全网吃瓜黑料入口直达链接与网址导航',
      url: `${SITE_URL}/`,
      inLanguage: 'zh-CN',
      isPartOf: { '@type': 'WebSite', url: `${SITE_URL}/` },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: `${SITE_URL}/`,
        },
      ],
    },
    {
      '@type': 'ItemList',
      name: '热门吃瓜入口分类',
      itemListElement: navCategories.map((category, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: category.name,
        description: category.desc,
      })),
    },
    {
      '@type': 'ItemList',
      name: '热门直达入口',
      itemListElement: navEntries.slice(0, 10).map((entry, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: entry.name,
        description: entry.desc,
      })),
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqList.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ],
};

export default function Home() {
  const [keyword, setKeyword] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const scrollToEntries = useCallback(() => {
    const target = document.getElementById('hot');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  const handleSearch = useCallback(
    (next: string) => {
      setKeyword(next);
      setActiveCategory('all');
      scrollToEntries();
    },
    [scrollToEntries],
  );

  const handleSelectCategory = useCallback(
    (category: string) => {
      setActiveCategory(category);
      setKeyword('');
      scrollToEntries();
    },
    [scrollToEntries],
  );

  return (
    <div className="min-h-screen w-full bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <SiteHeader />
      <main className="w-full">
        <HeroSection onSearch={handleSearch} />
        <EntryExplorer
          keyword={keyword}
          setKeyword={setKeyword}
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
        />
        <CategorySection activeCategory={activeCategory} onSelectCategory={handleSelectCategory} />
        <FeaturedSection onJump={handleSearch} />
        <GuideSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}